// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5886": "f5f748c36a9b","7035": "19a0f2969fbb","794": "0e2790934bd0","9614": "312e23a8ddc9",}[chunkId] + ".css"
}